import { NgModule } from '@angular/core';
import { NotificationsPanelComponent } from './notifications-panel.component';
import { MatButtonModule } from '@angular/material/button';
import { MatBadgeModule } from '@angular/material/badge';
import { CommonModule, NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslationModule } from '@core/translation/translation.module';

@NgModule({
    declarations: [NotificationsPanelComponent],
    exports: [NotificationsPanelComponent],
    imports: [
        CommonModule,
        MatButtonModule,
        MatBadgeModule,
        NgIf,
        MatIconModule,
        MatTabsModule,
        TranslationModule
    ]
})
export class NotificationsPanelModule {

}
